<template lang="pug">
v-app-bar(:color='themeColor' dense dark fixed clipped-left app)
    v-app-bar-nav-icon(@click="toggleDrawer")
      v-icon menu 
    img(
        class="ml-4" 
        :src="logo" 
        height="26"
      )
    v-spacer(v-show="appMode")
    v-toolbar-title(v-show="appMode" class="blink" style="font-size:18px; margin-top: 0.1rem; font-weight: 600;").ml-1 UAT - Pastikan Anda tidak salah masuk
    v-spacer
    v-toolbar-title(v-if="this.$store.state.dataUsers.role != 'general'") Hi, {{ this.$store.state.dataUsers ? this.$store.state.dataUsers.user.full_name : '' }} 
      //- template(v-if="this.$store.state.dataUsers.name_role != 'general'") ({{ this.$store.state.dataUsers.name_role }})
      v-menu(:nudge-width="170" :nudge-left='170' :nudge-bottom='40')
          template(v-slot:activator='{ on, attrs }')
            v-btn(icon='' v-bind='attrs' v-on='on')
              v-icon perm_identity
          v-list
            v-list-item(to='/my-profile')
              v-icon.mr-2 person
              v-list-item-title My Profile 
            v-list-item(to='/setting')
              v-icon.mr-2 settings
              v-list-item-title Setting
            v-list-item(to='/log')
              img(src="../assets/icon/icon_log.svg" class="icon-toobar mr-2")
              v-list-item-title Log Activity
            v-list-item(to='/logout')
              img(src="../assets/icon/icon_logout.svg" class="icon-toobar mr-2")
              v-list-tile-title Logout
    v-toolbar-title(v-if="this.$store.state.dataUsers.role == 'general'") Hi, {{ this.$store.state.dataUsers.user.full_name }} 
      v-menu(:nudge-width="170" :nudge-left='170' :nudge-bottom='40')
          template(v-slot:activator='{ on, attrs }')
            v-btn(icon='' v-bind='attrs' v-on='on')
              v-icon.mr-2 perm_identity
          v-list
            v-list-item(to='/my-profile')
              v-icon.mr-2 person
              v-list-item-title My Profile 
            v-list-item(to='/logout')
              img(src="../assets/icon/icon_logout.svg" class="icon-toobar mr-2")
              v-list-tile-title Logout   
         
//-v-toolbar(:color='colorTheme' dense dark fixed clipped-left app)
    //-     //- v-toolbar-side-icon(@click="toggleDrawer")
    //-     //- v-toolbar-title {{ title }}
    //-     v-spacer
    //-     v-toolbar-title Hi, {{ this.$store.state.dataUsers.fullname }} &nbsp;
    //-     v-menu(:nudge-width="170" :nudge-left='170' :nudge-bottom='40')
    //-       v-toolbar-title(slot='activator')
    //-         img(src="../assets/avatar_my_profile.png" style="margin:7px 0 0 0" width="21px")
    //-       v-list
    //-         v-list-tile(v-if="$store.state.dataUsers.department !== 'BOD'" to='/my-profile')
    //-           v-list-tile-action
    //-             v-icon person
    //-           v-list-tile-title My Profile
    //-         v-list-tile(v-if="$store.state.dataUsers.department !== 'BOD'" to='/wa-register')
    //-           v-list-tile-action
    //-             img(src="../assets/whatsapp_icon_grey.png" style="margin: 2px" width="24px")
    //-           v-list-tile-title Add Whatsapp Number
    //-         v-list-tile(@click="tgRegister")
    //-           v-list-tile-action
    //-             img(src="../assets/telegram_icon_grey.png" style="margin: 2px" width="22px")
    //-           v-list-tile-title Pairing Telegram
    //-         v-list-tile(to='/logout')
    //-           v-list-tile-action
    //-             v-icon exit_to_app
    //-           v-list-tile-title Logout
</template>

<script>
import axios from 'axios'
import { mapMutations, mapState } from "vuex";
import md5 from 'md5';
export default {
  data: () => ({
    role: '',
    overlay: false,
    bu_id: null,
    appMode: false
  }),
  name: "Toolbar",
  props: {
    title: String
  },
  computed: {
    themeColor() {
      return this.$store.getters.getThemeColor
    },
    logo() {
      return this.$store.getters.getLogo
    }
  },  
  mounted() {
    if ( process.env.VUE_APP_MODE != 'prod' ) {
      this.appMode = true
    } else {
      this.appMode = false
    }
  },
  methods: {
    ...mapMutations(["toggleDrawer"]),
  },
};
</script>

<style>
.icon-toobar{
  color: #737373;
}
.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
</style>